<template>
    <div class="row justify-content-center animated fadeInDown">
        <loading v-if="loading" message="Авторизирую..."></loading>
        <form v-else class="col-lg-5 col-md-8 col-sm-12" v-on:submit.prevent="handleLoginFormSubmit()">
            <div class="card-group mb-0">
                <div class="card p-4">
                    <div class="card-block">
                        <h1>Войти в Аларм План</h1>
                        <p class="text-muted">Войдите в свой аккаунт</p>
                        <div class="mb-1">
                            <div class="input-group" v-bind:class="{ 'has-danger': error || $v.login.email.$error }">
                                <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
                                <input class="form-control" id="email" type="email" v-model="login.email" required autofocus placeholder="Электронная почта"  @input="$v.login.email.$touch()">
                            </div>
                            <small class="help-block text-danger" v-if="error">Ошибка авторизации</small>
                            <small class="help-block text-danger" v-if="$v.login.email.$error">Укажите валидный адрес электронной почты</small>
                        </div>
                        <div class="mb-1">
                            <div class="input-group" v-bind:class="{ 'has-danger': error || $v.login.password.$error }">
                                <span class="input-group-addon"><i class="icon-lock"></i></span>
                                <input class="form-control" id="password" type="password" v-model="login.password" required placeholder="Пароль" @input="$v.login.password.$touch()">
                            </div>
                            <small class="help-block text-danger" v-if="error">Неправильный email или пароль</small>
                            <small class="help-block text-danger" v-if="$v.login.password.$error">Пароль должен быть не менее 6 символов</small>
                        </div>
                        <div class="input-group mb-1">
                            <label class="switch switch-text switch-primary-outline-alt mr-1">
                                <input type="checkbox" v-model="login.remember" class="switch-input" checked>
                                <span class="switch-label" data-on="On" data-off="Off"></span>
                                <span class="switch-handle"></span>
                            </label>
                            Запомнить меня
                        </div>
                        <div class="row mb-2">
                            <div class="col-6">
                                <button :class="{ 'disabled': $v.login.$invalid }" :disabled="$v.login.$invalid"  type="submit" class="btn btn-primary px-4">Войти</button>
                            </div>
                            <div class="col-6 text-right">
                                <router-link :to="{ name: 'RemindPassword' }">Забыли пароль?</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
  import { loginUrl } from './../../config'
  import { required, minLength, email } from 'vuelidate/lib/validators'
  export default {
    name: 'login',
    components: {},
    computed: {
      name () {
        return this.$route.name
      },

      list () {
        return this.$route.matched
      }
    },
    data () {
      return {
        login: {
          email: null,
          password: null,
          remember: false
        },
        error: false,
        loading: false
      }
    },
    methods: {
      handleLoginFormSubmit () {
        this.error = false
        this.loading = true
        const postData = {
          email: this.login.email,
          password: this.login.password
        }
        const authUser = {}
        this.$http.post(loginUrl, postData).then((response) => {
          if (response.status === 200) {
            authUser.access_token = response.data.meta.token
            if (this.login.remember) {
              window.localStorage.setItem('authUser', JSON.stringify(authUser))
            } else {
              window.sessionStorage.setItem('authUser', JSON.stringify(authUser))
            }
            this.loading = false
            this.$router.push({name: 'Orders'})
          }
        }, (response) => {
          this.error = true
          this.loading = false
          console.log(response.data)
        })
      }
    },
    validations: {
      login: {
        email: {
          required,
          email
        },
        password: {
          required,
          minLength: minLength(6)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?80988a9a